/**
 * Permission gating.
 *
 * Per AGENTS.md §17 the policy is permission-driven, not role-driven.
 * Components ask `useHasPermission("session.create")` — never
 * "is the user an org_admin?". The slug list comes from /auth/me, which
 * the backend computes by walking Membership → Roles → Permissions for
 * the active org. The same slug is enforced server-side by the
 * `HasOrgPermission` DRF class, so a UI-side gate cannot grant access
 * the API would refuse — it only hides options the user can't use.
 */
import { useMe } from "./auth";

export function useHasPermission(slug: string): boolean {
  const me = useMe();
  return me.data?.permissions.includes(slug) ?? false;
}

export function useHasAnyPermission(slugs: readonly string[]): boolean {
  const me = useMe();
  const set = new Set(me.data?.permissions ?? []);
  return slugs.some((s) => set.has(s));
}

export function useHasAllPermissions(slugs: readonly string[]): boolean {
  const me = useMe();
  const set = new Set(me.data?.permissions ?? []);
  return slugs.every((s) => set.has(s));
}